import styled from "@mui/material/styles/styled";
import { PatientColorMap } from "../../layout/patientColorMap";
import { GenericButton } from "./genericButton";

//region [[ Styles ]]
export const FlexEndWrapper = styled("div")({
  display: "flex",
  justifyContent: "flex-end",
});

export const FlexCenterWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  flexWrap: "wrap",
  padding: "24px 0",
  backgroundColor: PatientColorMap.Background,
  borderRadius: "0 80px 0 0",
});

export const FlexMultiLineWrapper = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  flexWrap: "wrap",
  padding: "24px 0",
  gap: "10px",
  backgroundColor: PatientColorMap.Background,
  borderRadius: "0 80px 0 0",
});

export const ActionButton = styled(GenericButton)({
  "&.generic-button": {
    backgroundColor: PatientColorMap.Primary,
    color: "white",
    height: "55px",
    borderRadius: "68px",
  },
});

export const MiniActionButton = styled(GenericButton)({
  "&.generic-button": {
    backgroundColor: PatientColorMap.Primary,
    color: "white",
    height: "28px",
    margin: "1px",
    borderRadius: "12px",
  },
});
//endregion [[ Styles ]]
